import { LoadingIcon as LoadingDefault } from "@packages/ds";
import styled from "styled-components";

import * as O from "src/organization/pages/billing/components/Overview/BillingOverview.styles";

export const ResourcesTable = styled(O.BaseBillingTable)`
  grid-template-columns: repeat(6, auto) max-content;
`;

export const BreakdownTable = styled.div<{
  isCurrent: boolean;
}>`
  display: grid;
  gap: 6px 24px;
  align-items: center;

  ${({ isCurrent }) =>
    `grid-template-columns: 1.2fr repeat(${isCurrent ? 3 : 2}, 1fr) 0.7fr;`}
`;

export const ProjectTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 975px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const Loading = styled(LoadingDefault)`
  display: flex;
  margin: 10px auto;
`;

export const EnvTypeText = styled.span`
  font-size: 12px;
  line-height: 20px;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
  color: var(--section-slate-color, var(--slate));
  background-color: var(
    --section-color-neutral-300-background-color,
    var(--color-neutral-300)
  );
`;

export const PausedIconWrapper = styled.div`
  display: flex;
  gap: 5px;
`;

export const BodyTextSubtleWide = styled(O.BodyTextSubtle)`
  grid-column: 2 / -3;
`;

export const AccordionContainer = styled.div`
  width: 100%;
  display: grid;
  grid-column: 1 / -1;
`;

export const AccordionWrapper = styled.div`
  h3 {
    font-size: 15px;
    color: var(--mode-text-neutral-default);

    p {
      font-weight: 600;
      margin: 0;
    }
  }
`;

export const AccordionItemWrapper = styled.div`
  width: 100%;
  display: grid;
  align-items: center;
  gap: 6px 24px;
  grid-template-columns: 1.2fr repeat(2, 1fr) 0.7fr;
`;

export const ProjectFreeWrapper = styled.div`
  line-height: 32px;
  p {
    color: var(--mode-text-neutral-default);
    font-weight: 600;
  }
`;

export const AccordionTitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const TriggerSibling = styled.div`
  color: var(--section-ebony-light-color, var(--ebony-light));
  line-height: 24px;
  font-size: 15px;
  font-weight: 400;
`;
